import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledSeenStatusFilter = styled('div')(
  () => css`
    .filter-seen-status {
      &.MuiFormGroup-root {
        display: flex !important;
      }
    }
  `
);
